module.exports = "https://static.wanderu.com/ui-react/_next/static/media/chiku-peek.8d1aa185.png";